import { Controller } from "@hotwired/stimulus"

// ACC Field Mappings — when the admin changes the ConsLog Action Item
// type for an Autodesk object type, rebuild that panel's status
// dropdowns from the chosen type's statuses and update the column
// heading. Mirrors the approved mockup behaviour.
//
// Each panel carries `data-ext` (rfi/submittal/issue). The chosen
// type's statuses come from the `kinds` value embedded on the section.
export default class extends Controller {
  static values = { kinds: Array }

  kindChanged(event) {
    const panel = event.target.closest("[data-ext]")
    if (!panel) return

    const kindId = parseInt(event.target.value, 10)
    const kind = this.kindsValue.find((k) => k.id === kindId)
    const actions = kind ? kind.actions : []

    // Column heading reflects the selected type.
    const header = panel.querySelector("[data-acc-field-mappings-target='statusHeader']")
    if (header) header.textContent = kind ? `ConsLog Status for ${kind.name}` : "ConsLog Status"

    // Rebuild every status dropdown + the default dropdown in this panel.
    panel
      .querySelectorAll(
        "[data-acc-field-mappings-target='statusBody'] select, [data-acc-field-mappings-target='defaultSelect']"
      )
      .forEach((sel) => {
        const isDefault = sel.dataset.accFieldMappingsTarget === "defaultSelect"
        const placeholder = isDefault ? "— none (skip) —" : "— not mapped —"
        const opts = [`<option value="">${placeholder}</option>`].concat(
          actions.map((a) => `<option value="${a.id}">${this._esc(a.name)}</option>`)
        )
        sel.innerHTML = opts.join("")
      })
  }

  _esc(str) {
    const d = document.createElement("div")
    d.textContent = str == null ? "" : String(str)
    return d.innerHTML
  }
}
